<template>
  <div class="sqs-block html-block sqs-block-html">
    <div class="sqs-block-content">
      <h1>My Account</h1>

      <h2 class="account-heading">My {{leaderboardYear}} Data</h2>

      <table class="table" v-if="user">
        <tbody class="row">
          <tr>
            <td>Username:</td>
            <td>{{ user.username }}</td>
          </tr>
          <tr v-if="user.n_count > 0">
            <td>Leaderboard Rank:</td>
            <td>{{ user.rank | number }}</td>
          </tr>
          <tr>
            <td># Videos Watched:</td>
            <td>{{ user.n_count | number }}</td>
          </tr>
          <tr>
            <td># Fish Counted:</td>
            <td>{{ user.sum_count | number }}</td>
          </tr>
        </tbody>
      </table>

      <h2 class="account-heading">Change Username</h2>

      <div class="form-wrapper">
        <div class="form-inner-wrapper">
          <form v-on:submit.prevent="updateUsername">
            <div class="field-list clear">
              <div class="form-item field text required">
                <label class="title" for="username-field">
                  Username <span class="required">*</span>
                </label>
                <div class="description">
                  Your Username may be shown publicly on the Leaderboard. Must be at least 3
                  characters.
                </div>
                <input
                  class="field-element text"
                  type="text"
                  id="username-field"
                  name="username"
                  v-model="username">
                <span v-if="usernameForm.submitted && !$v.username.required" class="is-danger">
                  Username is required.
                </span>
                <span v-if="usernameForm.submitted && !$v.username.minLength" class="is-danger">
                  Must be at least 3 characters.
                </span>
              </div>
            </div>
            <div class="form-button-wrapper form-button-wrapper--align-left">
              <input
                class="button sqs-system-button sqs-editable-button" type="submit" value="Submit">
            </div>
            <p v-if="usernameForm.message">{{ usernameForm.message }}</p>
            <p v-if="usernameForm.error" class="is-danger">{{ usernameForm.error }}</p>
          </form>
        </div>
      </div>

      <h2 class="account-heading">Personal Information</h2>
      <div style="margin-bottom:20px">
        The following information will only be accessible to MyRWA staff and used for maintaining contact lists. We will never share your information or email address with any outside organization.
      </div>
      <div class="form-wrapper">
        <div class="form-inner-wrapper">
          <form v-on:submit.prevent="updateInfo">
            <div class="field-list clear">
              <fieldset class="form-item fields name">
                <legend class="title">Name</legend>
                <div class="field first-name">
                  <label class="caption">
                    <input class="field-element field-control" name="fname" x-autocompletetype="given-name" type="text" spellcheck="false" maxlength="30" data-title="First" v-model="firstName">
                    <span class="caption-text">First Name</span>
                  </label>
                </div>
                <div class="field last-name">
                  <label class="caption">
                    <input class="field-element field-control" name="lname" x-autocompletetype="surname" type="text" spellcheck="false" maxlength="30" data-title="Last" v-model="lastName">
                    <span class="caption-text">Last Name</span>
                  </label>
                </div>
              </fieldset>
              <div v-if="infoForm.submitted && !$v.firstName.maxLength" class="is-danger" style="margin-bottom:10px">
                First name must be less than 250 characters.
              </div>
              <div v-if="infoForm.submitted && !$v.lastName.maxLength" class="is-danger" style="margin-bottom:10px">
                Last name must be less than 250 characters.
              </div>
              <div class="form-item field text">
                <label class="title" for="text-zip-field">
                  Zip Code
                </label>
                <input class="field-element text" type="text" id="text-zip-field" v-model="zip">
                <span v-if="infoForm.submitted && !$v.zip.maxLength" class="is-danger">
                  Zip code must be less 10 characters or less.
                </span>
              </div>
            </div>
            <div class="form-button-wrapper form-button-wrapper--align-left">
              <input class="button sqs-system-button sqs-editable-button" type="submit" value="Submit">
            </div>
            <p v-if="infoForm.message">{{ infoForm.message }}</p>
            <p v-if="infoForm.error" class="is-danger">{{ infoForm.error }}</p>
          </form>
        </div>
      </div>

      <h2 class="account-heading">Communication Preferences</h2>
      <div class="form-wrapper">
        <div class="form-inner-wrapper">
          <form v-on:submit.prevent="updateComm">
            <div class="field-list clear">
              <fieldset class="form-item field checkbox">
                <div class="option">
                  <label>
                    <input type="checkbox" name="checkbox-allow-email-field" v-model="allowEmail">
                    Yes, I opt-in to receive emails from MyRWA
                  </label>
                </div>
              </fieldset>
            </div>
            <div class="form-button-wrapper form-button-wrapper--align-left">
              <input class="button sqs-system-button sqs-editable-button" type="submit" value="Submit">
            </div>
            <p v-if="commForm.message">{{ commForm.message }}</p>
            <p v-if="commForm.error" class="is-danger">{{ commForm.error }}</p>
          </form>
        </div>
      </div>

      <h2 class="account-heading">Change Email</h2>
      <div class="form-wrapper">
        <div class="form-inner-wrapper">
          <form v-on:submit.prevent="updateEmail">
            <div class="field-list clear">
              <div class="form-item field email required">
                <label class="title" for="email-field">
                  Email Address <span class="required">*</span>
                </label>
                <input
                  class="field-element"
                  name="email"
                  x-autocompletetype="email"
                  type="text"
                  spellcheck="false"
                  id="email-field"
                  v-model="email">
                <span v-if="emailForm.submitted && !$v.email.required" class="is-danger">
                  Email is required.
                </span>
                <span v-if="emailForm.submitted && !$v.email.email" class="is-danger">
                  Email address is not valid.
                </span>
              </div>
            </div>
            <div class="form-button-wrapper form-button-wrapper--align-left">
              <input
                class="button sqs-system-button sqs-editable-button" type="submit" value="Submit">
            </div>
            <p v-if="emailForm.message">{{ emailForm.message }}</p>
            <p v-if="emailForm.error" class="is-danger">{{ emailForm.error }}</p>
            <p v-if="emailForm.loginRequired" class="is-danger">
              Please <router-link to="/login?redirect=/account">log in</router-link> again to change
              your email.
            </p>
          </form>
        </div>
      </div>

      <h2 class="account-heading">Change Password</h2>
      <div class="form-wrapper">
        <div class="form-inner-wrapper">
          <form v-on:submit.prevent="updatePassword">
            <div class="field-list clear">
              <div class="form-item field password required">
                <label class="title" for="password-field">
                  New Password <span class="required">*</span>
                </label>
                <div class="description">
                  Password must be at least 6 characters.
                </div>
                <input
                  class="field-element"
                  type="password"
                  id="password-field"
                  name="password"
                  v-model="password">
                <span v-if="passwordForm.submitted && !$v.password.required" class="is-danger">
                  Password is required.
                </span>
                <span v-if="passwordForm.submitted && !$v.password.minLength" class="is-danger">
                  Password must be at least 6 characters.
                </span>
              </div>
              <div class="form-item field password required">
                <label class="title" for="password2-field">
                  Confirm New Password <span class="required">*</span>
                </label>
                <input
                  class="field-element"
                  type="password"
                  id="password2-field"
                  name="password2"
                  v-model="password2">
                <span
                  v-if="passwordForm.submitted && !$v.password2.sameAsPassword"
                  class="is-danger">
                  Passwords must be identical.
                </span>
              </div>
            </div>
            <div class="form-button-wrapper form-button-wrapper--align-left">
              <input
                class="button sqs-system-button sqs-editable-button" type="submit" value="Submit">
            </div>
          </form>
          <p v-if="passwordForm.message"><span v-html="passwordForm.message"></span></p>
          <p v-if="passwordForm.error">{{ passwordForm.error }}</p>
          <p v-if="passwordForm.loginRequired">
            Please <router-link to="/login?redirect=/account">log in</router-link> again to change
            your password.
          </p>
        </div>
      </div>

      <h2 class="account-heading">Delete Account</h2>
      <div class="sqs-block button-block sqs-block-button delete-button">
        <div class="sqs-block-content">
          <div class="sqs-block-button-container--left">
            <a
              class="sqs-block-button-element--medium sqs-block-button-element"
              href="#"
              v-on:click.stop="deleteAccount">
              Delete Account
            </a>
          </div>
        </div>
      </div>
      <p class="is-danger"><strong>Warning</strong>:&nbsp;This cannot be undone!</p>
      <p v-if="deleteButtonForm.loginRequired">
        Please <router-link to="/login?redirect=/account">log in</router-link> again then return
        to this page to delete your account.
      </p>
      <p v-if="deleteButtonForm.error">{{ deleteButtonForm.error }}</p>
    </div>
  </div>
</template>

<script>
import { required, email, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

import { number } from '@/filters'

export default {
  name: 'account',
  data () {
    return {
      username: null,
      email: null,
      password: null,
      password2: null,
      firstName: null,
      lastName: null,
      zip: null,
      allowEmail: null,
      usernameForm: {
        message: null,
        error: null,
        submitted: false
      },
      emailForm: {
        message: null,
        error: null,
        submitted: false,
        loginRequired: false
      },
      passwordForm: {
        message: null,
        error: null,
        submitted: false,
        loginRequired: false
      },
      infoForm: {
        message: null,
        error: null,
        submitted: false
      },
      commForm: {
        message: null,
        error: null,
        submitted: false
      },
      deleteButtonForm: {
        error: null,
        submitted: false,
        loginRequired: false
      }
    }
  },
  filters: {
    number
  },
  validations: {
    username: {
      required,
      minLength: minLength(3)
    },
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
    },
    password2: {
      sameAsPassword: sameAs('password')
    },
    firstName: {
      maxLength: maxLength(250)
    },
    lastName: {
      maxLength: maxLength(250)
    },
    zip: {
      maxLength: maxLength(10)
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      leaderboardYear: 'leaderboardYear'
    })
  },
  mounted () {
    if (!this.user) return

    this.username = this.user.username
    this.firstName = this.user.first_name
    this.lastName = this.user.last_name
    this.zip = this.user.zip
    this.allowEmail = this.user.allow_email
  },
  methods: {
    updateUsername () {
      this.usernameForm.submitted = true
      this.usernameForm.message = null
      this.usernameForm.error = null

      if (this.username === this.user.username) {
        this.usernameForm.error = 'Username has not been changed'
      } else if (!this.$v.username.$invalid) {
        this.$auth.updateUsername(this.username)
          .then(() => {
            this.usernameForm.message = 'Username has been updated'
            this.usernameForm.submitted = false
            setTimeout(() => {
              this.usernameForm.message = null
            }, 3000)
          })
          .catch((err) => {
            this.usernameForm.error = err.message || 'Unknown error occurred.'
            console.log(err)
          })
      }
    },
    updateEmail () {
      this.emailForm.submitted = true
      this.emailForm.loginRequired = false
      this.emailForm.message = null
      this.emailForm.error = null

      if (!this.$v.email.$invalid) {
        this.$auth.updateEmail(this.email)
          .then(() => {
            this.email = null
            this.emailForm.message = 'Email has been updated'
            this.emailForm.submitted = false
            setTimeout(() => {
              this.emailForm.message = null
            }, 3000)
          })
          .catch((err) => {
            if (err.code === 'auth/requires-recent-login') {
              this.emailForm.loginRequired = true
            } else {
              this.emailForm.error = err.message || 'Unknown error occurred.'
              console.log(err)
            }
          })
      }
    },
    updatePassword () {
      this.passwordForm.submitted = true
      this.passwordForm.loginRequired = false
      this.passwordForm.message = null
      this.passwordForm.error = null

      if (!this.$v.password.$invalid && !this.$v.password2.$invalid) {
        this.$auth.updatePassword(this.password)
          .then(() => {
            this.password = null
            this.password2 = null
            this.passwordForm.message = 'Password has been updated'
            this.passwordForm.submitted = false
            setTimeout(() => {
              this.passwordForm.message = null
            }, 3000)
          })
          .catch((err) => {
            if (err.code === 'auth/requires-recent-login') {
              this.passwordForm.loginRequired = true
            } else {
              this.passwordForm.error = err.message || 'Unknown error occurred.'
              console.log(err)
            }
          })
      }
    },
    updateInfo () {
      this.infoForm.submitted = true
      this.infoForm.message = null
      this.infoForm.error = null

      if (!this.$v.firstName.$invalid && !this.$v.lastName.$invalid && !this.$v.zip.$invalid) {
        const payload = {
          first_name: this.firstName,
          last_name: this.lastName,
          zip: this.zip,
          updated: true
        }
        this.$auth.updateAttributes(payload)
          .then(() => {
            this.infoForm.message = 'Personal information has been updated'
            this.infoForm.submitted = false
            setTimeout(() => {
              this.infoForm.message = null
            }, 3000)
          })
          .catch((err) => {
            this.infoForm.error = err.message || 'Unknown error occurred.'
            console.log(err)
          })
      }
    },
    updateComm () {
      this.commForm.submitted = true
      this.commForm.message = null
      this.commForm.error = null

      const payload = {
        allow_email: this.allowEmail
      }
      this.$auth.updateAttributes(payload)
        .then(() => {
          this.commForm.message = 'Communication preferences have been updated'
          this.commForm.submitted = false
          setTimeout(() => {
            this.commForm.message = null
          }, 3000)
        })
        .catch((err) => {
          this.commForm.error = err.message || 'Unknown error occurred.'
          console.log(err)
        })
    },
    deleteAccount () {
      this.$auth.delete()
        .then(() => {
          this.$router.push('/deleted')
        })
        .catch((err) => {
          if (err.code === 'auth/requires-recent-login') {
            this.deleteButtonForm.loginRequired = true
          } else {
            this.deleteButtonForm.error = err.message || 'Unknown error occurred.'
            console.log(err)
          }
        })
    }
  }
}

</script>

<style scoped>
h2.account-heading {
  margin-top: 40px;
}
.delete-button {
  padding-left: 0;
}
.description {
  white-space: normal !important;
}
.table {
  width: 400px;
  table-layout: fixed;
  border-left: 1px solid #AAA;
}
.row td {
  padding-left: 5px;
  padding-right: 10px;
}
.row td:first-child {
  font-family: "proxima-nova","Helvetica Neue",Helvetica,Arial,sans-serif;
  width: 190px;
  text-align: right;
}
.row {
  font-size: 20px;
}

</style>
